import { createContext, type ReactNode,useContext } from "react";

// ─────────────────────────────────────────────────────────────────────────────
// NodeActionsContext — exposes per-node action handlers (delete, etc.) so
// shared node primitives like <BaseNode> can render hover-revealed action
// chrome without each node type re-plumbing the call chain.
//
// RuleBuilder wraps the canvas in <NodeActionsProvider value={{ onDeleteNode }}>
// and BaseNode reads from this context. Nodes that should NOT be deletable
// (reaction_location) can skip rendering the delete affordance.
// ─────────────────────────────────────────────────────────────────────────────

export interface NodeActions {
	onDeleteNode: (nodeId: string) => void;
}

const NodeActionsContext = createContext<NodeActions | null>(null);

export const NodeActionsProvider = ({
	value,
	children
}: {
	value: NodeActions;
	children: ReactNode;
}) => <NodeActionsContext.Provider value={value}>{children}</NodeActionsContext.Provider>;

export const useNodeActions = (): NodeActions | null => useContext(NodeActionsContext);
